import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Tooltip as TooltipComponent, OverlayTrigger } from "react-bootstrap";
import { v4 as uuid } from "uuid";

class Tooltip extends PureComponent {
	constructor(props) {
		super(props);
		this.uuid = uuid();
	}

	render() {
		const { className, content, placement, children } = this.props;

		const tooltip = (
			<TooltipComponent
				id={this.uuid}
				className={className}
			>
				{content}
			</TooltipComponent>
		);

		return (
			<OverlayTrigger
				placement={placement}
				overlay={tooltip}
			>
				{children}
			</OverlayTrigger>
		);
	}
}

Tooltip.propTypes = {
	children: PropTypes.element.isRequired,
	className: PropTypes.string,
	placement: PropTypes.oneOf(["right", "top", "left", "bottom"]),
	content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
};

Tooltip.defaultProps = {
	className: "tooltip-default",
	placement: "top",
};

export default Tooltip;
